<template>
  <span class="scaling-svg-container">
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="-0.5 -0.5 19.25 19.25" class="scaling-svg">
      <g id="Group_16" data-name="Group 16" transform="translate(-18.427 -1.427)">
        <circle id="Oval" cx="9" cy="9" r="9" transform="translate(18.427 1.427)" />
        <path
          id="Path_2"
          data-name="Path 2"
          d="M0,2.2,2.393,4.592,6.573,0"
          transform="translate(23.983 8.36)"
          fill="none"
          stroke="#fff"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="1.5"
        />
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class CheckboxOnIcon extends Vue {}
</script>

<style></style>
